export const numberFormatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

/**
 * EL formato del dinero en todo el admin: `$18,199.00`, `-$56.00`.
 *
 * Siempre dos decimales (hasta el 2026-09-27 usaba `minimumFractionDigits: 0` y la
 * misma columna mezclaba `$6,280.6` con `$1,000`; por eso el panel de cajas y el
 * modal de cobro se habían hecho su propia copia). Tolera `undefined`/`NaN` como 0:
 * un importe ausente no puede pintar `$NaN`.
 */
export const currencyFormatter = (value: number | undefined | null): string => {
    const amount = Number(value) || 0;
    return `${amount < 0 ? '-' : ''}$${numberFormatter.format(Math.abs(amount))}`;
};
